// extracted by mini-css-extract-plugin
module.exports = {"GridLookbookSingleImage":"styles_GridLookbookSingleImage__1_dyc","image":"styles_image__nUejY","text":"styles_text__62VCo","ratio":"styles_ratio__ovuqg"};